import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: BACKEND_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (username, email, password) => api.post('/auth/register', { username, email, password }),
  verify: () => api.get('/auth/verify'),
};

// Products
export const productsAPI = {
  getAll: (params) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
  create: (data) => api.post('/products', data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
  uploadImage: (id, files) => {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('images', files[i]);
    }
    return api.post(`/products/${id}/images`, formData);
  },
  deleteImage: (id, index) => api.delete(`/products/${id}/images/${index}`),
};

// Categories
export const categoriesAPI = {
  getAll: () => api.get('/categories'),
};

// Banners
export const bannersAPI = {
  getAll: (params) => api.get('/banners', { params }),
  create: (file, title, redirect_url) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    formData.append('redirect_url', redirect_url);
    return api.post('/banners', formData);
  },
  update: (id, data) => api.put(`/banners/${id}`, data),
  delete: (id) => api.delete(`/banners/${id}`),
};

// Analytics
export const analyticsAPI = {
  track: (event) => api.post('/analytics/track', event),
  getStats: () => api.get('/analytics/stats'),
  getDaily: (days = 7) => api.get('/analytics/daily', { params: { days } }),
};

// Settings
export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

// Orders
export const ordersAPI = {
  create: (data) => api.post('/orders', data),
  getAll: (params) => api.get('/orders', { params }),
  getById: (id) => api.get(`/orders/${id}`),
  updateStatus: (id, status) => api.put(`/orders/${id}/status`, { status }),
};

export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}/files/${path}`;
};
